import React, { lazy, Suspense } from 'react';

const LazyDbDetail = lazy(() => import('./DbDetail'));

const DbDetail = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => (
  <Suspense fallback={null}>
    <LazyDbDetail {...props} />
  </Suspense>
);

export default DbDetail;
